import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { colors } from '../../assets';

type AttachmentCardStylesProps = {
  shouldShowPreview: boolean;
  hasDescription: boolean;
};

export const useStyles = makeStyles<Theme, AttachmentCardStylesProps>(theme => {
  const isLegacy = (theme as Theme & { legacy?: boolean }).legacy;

  return createStyles({
    wrapper: {
      padding: 16,
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateAreas: ({ hasDescription }) => `
        "fileIconHolder shortInfo actions"
        "fileIconHolder ${hasDescription ? 'description description' : 'shortInfo actions'}"
      `,
      gap: 16,

      [theme.breakpoints.down('xs')]: {
        gridTemplateAreas: ({ hasDescription }) =>
          `
          "fileIconHolder shortInfo shortInfo"
          ${hasDescription ? '"description description description"' : '"fileIconHolder shortInfo shortInfo"'}
          "actions actions actions"
        `,
      },
    },

    fileIconHolder: {
      flexShrink: 0,
      gridArea: 'fileIconHolder',
    },

    fileIcon: {
      width: 40,
      height: '48px !important',
    },

    preview: {
      width: 100,
      height: 107,
      objectFit: 'cover',
      borderRadius: 4,
      backgroundColor: theme.palette.grey[100],
    },

    previewContainer: {
      width: 100,
      height: 107,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      overflow: 'hidden',
      backgroundColor: theme.palette.grey[100],
    },

    pdfThumbnail: {
      width: 100,
      height: 107,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& canvas': {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
      },
    },

    pdfPreviewLoading: {
      width: 100,
      height: 107,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.grey[100],
    },

    shortInfo: {
      flex: 1,
      gridArea: 'shortInfo',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },

    primaryText: {
      fontSize: isLegacy ? 18 : 16,
      lineHeight: 1.4,
      color: colors.grey190,
      wordBreak: 'break-word',
    },

    secondaryText: {
      fontSize: isLegacy ? 18 : 16,
      lineHeight: 1.4,
      color: colors.grey140,
      wordBreak: 'break-word',
    },

    fileName: {
      width: 'fit-content',

      '&.clickable': {
        cursor: 'pointer',
      },
    },

    actions: {
      display: 'flex',
      alignItems: 'center',
      gridArea: 'actions',

      '&.skeleton': {
        gap: 16,
      },

      [theme.breakpoints.down('xs')]: {
        justifyContent: 'space-between',
      },
    },

    action: {
      margin: '0 12px',
    },

    actionButton: {
      width: 24,
      height: '24px !important',

      [theme.breakpoints.down('xs')]: {
        fontSize: '32px !important',
        width: 32,
        height: '32px !important',
      },
    },

    description: {
      width: '100%',
      gridArea: 'description',

      [theme.breakpoints.up('sm')]: {
        paddingRight: 16,
      },
    },

    descriptionText: {
      whiteSpace: 'pre-wrap',
    },
  });
});
